import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-i_close",
  "use": "icon-i_close-usage",
  "viewBox": "0 0 34.02 34.02",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34.02 34.02\" id=\"icon-i_close\"><title>icon_画板</title><path d=\"M26.13,27.5a1.34,1.34,0,0,1-1-.41L6.92,8.86A1.37,1.37,0,0,1,8.86,6.92L27.09,25.16a1.35,1.35,0,0,1,0,1.93A1.33,1.33,0,0,1,26.13,27.5Z\" /><path d=\"M7.89,27.5a1.38,1.38,0,0,1-1-2.34L25.16,6.92A1.37,1.37,0,1,1,27.1,8.86L8.86,27.09A1.37,1.37,0,0,1,7.89,27.5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol